export default "__VITE_ASSET__jQGqs0Th__"